import React, { useState, useEffect, useRef } from 'react';

/* ─── SVG Icons ─── */
const MapPinIcon = () => (
  <svg viewBox="0 0 48 48" width="36" height="36" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M24 4C17.4 4 12 9.4 12 16c0 9 12 28 12 28s12-19 12-28c0-6.6-5.4-12-12-12z" stroke="#ff4444" strokeWidth="2" fill="rgba(255,68,68,0.12)"/>
    <circle cx="24" cy="16" r="4" stroke="#ff4444" strokeWidth="2" fill="rgba(255,68,68,0.2)"/>
  </svg>
);
const PhoneIcon = () => (
  <svg viewBox="0 0 48 48" width="36" height="36" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M10 6h10l4 10-6 4a22 22 0 0010 10l4-6 10 4v10a4 4 0 01-4 4C18 42 6 30 6 10a4 4 0 014-4z" stroke="#ff4444" strokeWidth="2" fill="rgba(255,68,68,0.12)" strokeLinejoin="round"/>
  </svg>
);
const MailIcon = () => (
  <svg viewBox="0 0 48 48" width="36" height="36" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="6" y="10" width="36" height="28" rx="3" stroke="#ff4444" strokeWidth="2" fill="rgba(255,68,68,0.12)"/>
    <polyline points="6,10 24,26 42,10" stroke="#ff4444" strokeWidth="2" strokeLinejoin="round"/>
  </svg>
);
const EmailSocial = () => (
  <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <rect x="2" y="4" width="20" height="16" rx="2"/><polyline points="2,4 12,13 22,4"/>
  </svg>
);
const MessengerIcon = () => (
  <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <path d="M12 2C6.5 2 2 6.1 2 11.2c0 2.8 1.3 5.3 3.4 7v3.5l3.3-1.8c.9.2 1.9.3 2.9.3 5.5 0 10-4.1 10-9.2S17.5 2 12 2z"/>
    <path d="M7 14l2.5-3 2.5 2 2.5-3 2.5 3" stroke="currentColor" strokeWidth="1.5"/>
  </svg>
);
const FacebookIcon = () => (
  <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <path d="M18 2h-3a5 5 0 00-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 011-1h3z"/>
  </svg>
);
const InstagramIcon = () => (
  <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <rect x="2" y="2" width="20" height="20" rx="5"/>
    <circle cx="12" cy="12" r="4"/>
    <circle cx="17.5" cy="6.5" r="0.8" fill="currentColor" stroke="none"/>
  </svg>
);
const YoutubeIcon = () => (
  <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <path d="M22.5 6.5s-.3-2-1.2-2.8C20.2 2.5 18.9 2.5 18.3 2.4 15.6 2.2 12 2.2 12 2.2s-3.6 0-6.3.2C5.1 2.5 3.8 2.5 2.7 3.7 1.8 4.5 1.5 6.5 1.5 6.5S1.3 8.8 1.3 11v2c0 2.3.2 4.5.2 4.5s.3 2 1.2 2.8c1.1 1.2 2.6 1.1 3.3 1.2C8.2 21.7 12 21.7 12 21.7s3.6 0 6.3-.2c.6-.1 1.9-.1 3-1.3.9-.8 1.2-2.8 1.2-2.8s.2-2.3.2-4.5v-2C22.7 8.8 22.5 6.5 22.5 6.5z"/>
    <polygon points="10,8.5 15.5,12 10,15.5" fill="currentColor" stroke="none"/>
  </svg>
);
const LinkedInIcon = () => (
  <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <path d="M16 8a6 6 0 016 6v7h-4v-7a2 2 0 00-2-2 2 2 0 00-2 2v7h-4v-7a6 6 0 016-6z"/>
    <rect x="2" y="9" width="4" height="12"/><circle cx="4" cy="4" r="2"/>
  </svg>
);
const DiscordIcon = () => (
  <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <path d="M20.3 4.4A19.2 19.2 0 0015.6 3c-.2.4-.5.9-.6 1.3a17.8 17.8 0 00-5.9 0C9 3.9 8.6 3.4 8.4 3A19.4 19.4 0 003.7 4.4C.5 9.3-.3 14 .1 18.7a19.4 19.4 0 005.9 3c.5-.7.9-1.4 1.3-2.2a12.6 12.6 0 01-2-.9c.2-.1.3-.2.5-.4a13.8 13.8 0 0011.8 0c.2.1.3.3.5.4-.7.4-1.3.7-2 1 .4.8.8 1.5 1.2 2.2a19.3 19.3 0 005.9-3c.5-5.4-.9-10-3.9-14.3zM8.5 15.7c-1.3 0-2.3-1.2-2.3-2.6s1-2.6 2.3-2.6 2.3 1.2 2.3 2.6-1 2.6-2.3 2.6zm7 0c-1.3 0-2.3-1.2-2.3-2.6s1-2.6 2.3-2.6 2.3 1.2 2.3 2.6-1 2.6-2.3 2.6z"/>
  </svg>
);
const LinkTreeIcon = () => (
  <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <path d="M12 2v8M8 6l4-4 4 4M6 10l6 4 6-4M6 15l6 4 6-4"/><line x1="12" y1="10" x2="12" y2="22"/>
  </svg>
);
const RocketIcon = () => (
  <svg viewBox="0 0 20 20" width="16" height="16" fill="none" stroke="white" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <path d="M10 2C10 2 14 5 14 11L10 15 6 11C6 5 10 2 10 2z" fill="rgba(255,255,255,0.15)"/>
    <circle cx="10" cy="8" r="2"/><path d="M6 11L3 16 7 14.5M14 11L17 16 13 14.5"/>
  </svg>
);
const SendIcon = () => (
  <svg viewBox="0 0 20 20" width="16" height="16" fill="none" stroke="white" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <line x1="22" y1="2" x2="11" y2="13"/><polygon points="22,2 15,22 11,13 2,9"/>
  </svg>
);

const contactIconMap = { '📍': <MapPinIcon />, '📞': <PhoneIcon />, '✉️': <MailIcon /> };
const socialIconMap = {
  'Email': <EmailSocial />, 'Messenger': <MessengerIcon />, 'Facebook': <FacebookIcon />,
  'Instagram': <InstagramIcon />, 'YouTube': <YoutubeIcon />, 'LinkedIn': <LinkedInIcon />,
  'Discord': <DiscordIcon />, 'LinkTree': <LinkTreeIcon />
};
const PARTNERSHIP_EMAIL = 'partnership@utmrobocon.com';

/* ─── Particle Canvas ─── */
const ParticleCanvas = () => {
  const ref = useRef(null);
  useEffect(() => {
    const c = ref.current; if (!c) return;
    const ctx = c.getContext('2d');
    let raf;
    const resize = () => { c.width = window.innerWidth; c.height = window.innerHeight; };
    resize(); window.addEventListener('resize', resize);
    const pts = Array.from({ length: 50 }, () => ({
      x: Math.random() * window.innerWidth, y: Math.random() * window.innerHeight,
      vx: (Math.random() - 0.5) * 0.35, vy: (Math.random() - 0.5) * 0.35,
      r: Math.random() * 1.4 + 0.4, a: Math.random() * 0.45 + 0.08,
    }));
    const draw = () => {
      ctx.clearRect(0, 0, c.width, c.height);
      pts.forEach(p => {
        p.x += p.vx; p.y += p.vy;
        if (p.x < 0) p.x = c.width; if (p.x > c.width) p.x = 0;
        if (p.y < 0) p.y = c.height; if (p.y > c.height) p.y = 0;
        ctx.beginPath(); ctx.arc(p.x, p.y, p.r, 0, Math.PI * 2);
        ctx.fillStyle = `rgba(255,68,68,${p.a})`; ctx.fill();
      });
      for (let i = 0; i < pts.length; i++) for (let j = i + 1; j < pts.length; j++) {
        const dx = pts[i].x - pts[j].x, dy = pts[i].y - pts[j].y, d = Math.sqrt(dx*dx+dy*dy);
        if (d < 120) {
          ctx.beginPath(); ctx.moveTo(pts[i].x, pts[i].y); ctx.lineTo(pts[j].x, pts[j].y);
          ctx.strokeStyle = `rgba(255,68,68,${0.07*(1-d/120)})`; ctx.lineWidth = 0.5; ctx.stroke();
        }
      }
      raf = requestAnimationFrame(draw);
    };
    draw();
    return () => { cancelAnimationFrame(raf); window.removeEventListener('resize', resize); };
  }, []);
  return <canvas ref={ref} style={{ position:'fixed',inset:0,zIndex:0,pointerEvents:'none' }} />;
};

/* ─── useInView ─── */
const useInView = (threshold = 0.12) => {
  const ref = useRef(null);
  const [inView, setInView] = useState(false);
  useEffect(() => {
    const obs = new IntersectionObserver(([e]) => { if (e.isIntersecting) setInView(true); }, { threshold });
    if (ref.current) obs.observe(ref.current);
    return () => obs.disconnect();
  }, [threshold]);
  return [ref, inView];
};

/* ─── Section Header ─── */
const SectionHeader = ({ tag, title, subtitle }) => (
  <div className="sh">
    <span className="sh-tag">{tag}</span>
    <h2 className="sh-title">{title}</h2>
    <div className="sh-bar" />
    {subtitle && <p className="sh-sub">{subtitle}</p>}
  </div>
);

/* ─── Main Component ─── */
const ContactUs = () => {
  const [heroVisible, setHeroVisible] = useState(false);
  const [formData, setFormData] = useState({ name: '', email: '', subject: '', message: '' });
  const [snackbar, setSnackbar] = useState({ open: false, message: '', progress: 100 });
  const snackbarTimer = useRef(null);
  const progressTimer = useRef(null);

  const [infoRef, infoInView] = useInView();
  const [socialRef, socialInView] = useInView();
  const [formRef, formInView] = useInView();
  const [ctaRef, ctaInView] = useInView();

  useEffect(() => { setTimeout(() => setHeroVisible(true), 120); }, []);

  const contactInfo = [
    { iconKey: '📍', title: 'Address', details: 'P10, UTM Robocon\nUTM Johor Bahru\n81310 Skudai, Johor', link: 'https://maps.app.goo.gl/svPfvYXJjGt66PSc6' },
    { iconKey: '📞', title: 'Phone', details: '+6018-665 9511\n(Team Leader)', link: 'tel:+60186659511' },
    { iconKey: '✉️', title: 'Email', details: `${PARTNERSHIP_EMAIL}\nPartnership Inquiries`, link: `mailto:${PARTNERSHIP_EMAIL}` },
  ];

  const socialLinks = [
    { key: 'Email', name: 'Email', account: PARTNERSHIP_EMAIL, link: `mailto:${PARTNERSHIP_EMAIL}`, color: '#EA4335' },
    { key: 'Messenger', name: 'Messenger', account: 'UTM Robocon Team', link: 'https://m.me/utmrbc', color: '#00B2FF' },
    { key: 'Facebook', name: 'Facebook', account: 'UTM Robocon Team', link: 'https://www.facebook.com/utmrbc', color: '#1877F2' },
    { key: 'Instagram', name: 'Instagram', account: '@utm.rbc', link: 'https://www.instagram.com/utm.rbc/', color: '#E4405F' },
    { key: 'YouTube', name: 'YouTube', account: 'UTM Robocon', link: 'https://www.youtube.com/@utmrobocon1445', color: '#FF0000' },
    { key: 'LinkedIn', name: 'LinkedIn', account: 'UTM Robocon Team', link: 'https://www.linkedin.com/company/utmrbc/about/', color: '#0A66C2' },
    { key: 'Discord', name: 'Discord', account: 'UTM ROBOCON Team', link: 'https://discord.gg/vFTe2rEqq8', color: '#5865F2' },
    { key: 'LinkTree', name: 'LinkTree', account: 'UTM RBC', link: 'https://linktr.ee/UTM_RBC', color: '#43E660' },
  ];

  const handleChange = e => setFormData({ ...formData, [e.target.name]: e.target.value });

  const showSnackbar = (msg) => {
    clearInterval(progressTimer.current); clearTimeout(snackbarTimer.current);
    setSnackbar({ open: true, message: msg, progress: 100 });
    let p = 100;
    progressTimer.current = setInterval(() => {
      p -= 2; setSnackbar(s => ({ ...s, progress: p }));
      if (p <= 0) clearInterval(progressTimer.current);
    }, 100);
    snackbarTimer.current = setTimeout(() => setSnackbar(s => ({ ...s, open: false })), 5000);
  };

  const handleSubmit = e => {
    e.preventDefault();
    const subject = formData.subject?.trim() || 'Partnership Inquiry';
    const body = [
      `Name: ${formData.name || '-'}`,
      `Email: ${formData.email || '-'}`,
      '',
      formData.message || '',
    ].join('\n');
    const mailtoUrl = `mailto:${PARTNERSHIP_EMAIL}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
    window.location.href = mailtoUrl;
    showSnackbar('Message transmitted! We will get back to you soon.');
    setFormData({ name: '', email: '', subject: '', message: '' });
  };

  return (
    <div className="cu ext-page">
      <ParticleCanvas />
      <div className="grid-bg" aria-hidden="true" />
      <div className="scanlines" aria-hidden="true" />
      <div className="radial-glow" aria-hidden="true" />

      <div className="wrapper">

        {/* ── HERO ── */}
        <section className={`hero ${heroVisible ? 'vis' : ''}`}>
          <div className="hero-sys-tag">
            <span className="sys-dot" /><span>UNIVERSITI TEKNOLOGI MALAYSIA // CONTACT_MODULE</span>
          </div>
          <h1 className="hero-title">
            CONTACT<br />
            <span className="hero-sub">UTM <span className="hero-red">ROBOCON</span></span>
          </h1>
          <div className="hero-divider">
            <div className="hd-line" /><span className="hd-label">INITIATE COMMS</span><div className="hd-line hd-line-r" />
          </div>
          <p className="hero-desc">
            Ready to connect with Malaysia's premier robotics team? Reach us through any active channel below.
          </p>
          <div className="hero-underline">
            <div className="hu-sweep" />
          </div>
        </section>

        {/* ── CONTACT INFO ── */}
        <section className={`sec ${infoInView ? 'sec-in' : ''}`} ref={infoRef}>
          <div className="sec-shell">
            <SectionHeader tag="// GET_IN_TOUCH" title="DIRECT CHANNELS" />
            <div className="info-grid">
            {contactInfo.map((c, i) => (
              <div
                className="glass-card info-card"
                key={i}
                onClick={() => window.open(c.link, '_blank')}
                style={{ animationDelay: `${i * 0.1}s` }}
              >
                <div className="card-glow-top" />
                <div className="info-icon-wrap">
                  <div className="info-icon-ring" />
                  {contactIconMap[c.iconKey]}
                </div>
                <h3 className="info-title">{c.title}</h3>
                <p className="info-details">{c.details}</p>
                <div className="card-edge" />
              </div>
            ))}
            </div>
          </div>
        </section>

        {/* ── SOCIAL ── */}
        <section className={`sec ${socialInView ? 'sec-in' : ''}`} ref={socialRef}>
          <div className="sec-shell">
            <SectionHeader tag="// SOCIAL_NETWORKS" title="CONNECT WITH US" subtitle="Follow our channels for live updates and behind-the-scenes content" />
            <div className="social-grid">
            {socialLinks.map((s, i) => (
              <a
                key={i}
                href={s.link}
                target="_blank"
                rel="noopener noreferrer"
                className="social-card"
                style={{ '--sc': s.color, animationDelay: `${i * 0.07}s` }}
              >
                <div className="sc-top">
                  <span className="sc-icon" style={{ color: s.color }}>{socialIconMap[s.key]}</span>
                  <span className="sc-name">{s.name}</span>
                </div>
                <p className="sc-account">{s.account}</p>
                <div className="sc-glow-line" />
                <div className="sc-hover-bg" />
              </a>
            ))}
            </div>
          </div>
        </section>

        {/* ── FORM ── */}
        <section className={`sec ${formInView ? 'sec-in' : ''}`} ref={formRef}>
          <div className="sec-shell">
            <SectionHeader tag="// TRANSMIT_MESSAGE" title="SEND US A MESSAGE" subtitle="Have a question or want to collaborate? We'd love to hear from you." />
            <div className="glass-card form-card">
            <div className="form-card-sweep" />
            <div className="card-glow-top" />
            <form className="form" onSubmit={handleSubmit} noValidate>
              <div className="form-row">
                <FormField label="NAME" name="name" type="text" value={formData.name} onChange={handleChange} placeholder="Your full name" />
                <FormField label="EMAIL" name="email" type="email" value={formData.email} onChange={handleChange} placeholder="your.email@example.com" />
              </div>
              <FormField label="SUBJECT" name="subject" type="text" value={formData.subject} onChange={handleChange} placeholder="What's this about?" />
              <div className="form-group">
                <label className="f-label">MESSAGE</label>
                <div className="f-input-wrap">
                  <textarea
                    name="message" value={formData.message} onChange={handleChange}
                    className="f-textarea" placeholder="Describe your inquiry in detail…" rows={6}
                  />
                  <div className="f-border-anim" />
                </div>
              </div>
              <button type="submit" className="submit-btn">
                <span className="sb-shine" />
                <span className="sb-inner"><SendIcon /> TRANSMIT MESSAGE</span>
              </button>
            </form>
              <div className="card-edge" />
            </div>
          </div>
        </section>

        {/* ── CTA ── */}
        <section className={`sec cta-sec ${ctaInView ? 'sec-in' : ''}`} ref={ctaRef}>
          <div className="sec-shell">
            <div className="glass-card cta-card">
            <div className="cta-sweep" />
            <div className="card-glow-top" />
            <div className="cta-alert"><span className="ca-dot" /><span>// RECRUITMENT_OPEN</span></div>
            <h2 className="cta-title">JOIN OUR COMMUNITY</h2>
            <p className="cta-desc">Be part of Malaysia's most innovative robotics team. Whether you're a student, industry professional, or robotics enthusiast — there's a place for you here.</p>
            <div className="cta-btns">
              <button className="btn-primary" onClick={() => window.open('https://linktr.ee/UTM_RBC', '_blank')}>
                <span className="btn-shine" />
                <span className="btn-inner"><RocketIcon /> VISIT LINKTREE</span>
              </button>
              <button className="btn-secondary" onClick={() => window.open('https://www.facebook.com/utmrbc', '_blank')}>
                FOLLOW US
              </button>
            </div>
              <div className="card-edge" />
            </div>
          </div>
        </section>

      </div>

      {/* ── SNACKBAR ── */}
      {snackbar.open && (
        <div className="snackbar">
          <div className="snackbar-inner">
            <div className="snackbar-glow-top" />
            <div className="sb-row">
              <span className="sb-check">
                <svg viewBox="0 0 20 20" width="18" height="18" fill="none">
                  <circle cx="10" cy="10" r="9" stroke="#44ff88" strokeWidth="1.5"/>
                  <polyline points="5.5,10.5 8.5,13.5 14.5,7.5" stroke="#44ff88" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </span>
              <span className="sb-msg">{snackbar.message}</span>
              <button className="sb-close" onClick={() => setSnackbar(s => ({ ...s, open: false }))}>×</button>
            </div>
            <div className="sb-progress"><div className="sb-bar" style={{ width: `${snackbar.progress}%` }} /></div>
          </div>
        </div>
      )}

      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Orbitron:wght@400;600;700;900&family=Rajdhani:wght@300;400;500;600;700&family=Share+Tech+Mono&display=swap');

        *,*::before,*::after{box-sizing:border-box;margin:0;padding:0}

        .cu {
          position:relative; min-height:100vh;
          background:#060608;
          font-family:'Rajdhani',-apple-system,BlinkMacSystemFont,sans-serif;
          color:#e0e0e0; overflow-x:hidden;
        }

        /* Overlays */
        .grid-bg {
          position:fixed;inset:0;z-index:1;pointer-events:none;
          background-image:
            linear-gradient(rgba(255,68,68,0.03) 1px,transparent 1px),
            linear-gradient(90deg,rgba(255,68,68,0.03) 1px,transparent 1px);
          background-size:72px 72px;
        }
        .scanlines {
          position:fixed;inset:0;z-index:2;pointer-events:none;
          background:repeating-linear-gradient(0deg,transparent,transparent 2px,rgba(0,0,0,0.055) 2px,rgba(0,0,0,0.055) 4px);
        }
        .radial-glow {
          position:fixed;inset:0;z-index:1;pointer-events:none;
          background:
            radial-gradient(ellipse at 20% 80%,rgba(255,34,34,0.07),transparent 55%),
            radial-gradient(ellipse at 80% 20%,rgba(255,34,34,0.05),transparent 55%);
        }

        .wrapper { position:relative;z-index:3;max-width:var(--external-content-max-width);margin:0 auto;padding:0 var(--external-content-x) var(--external-page-bottom); }
        .sec-shell { width:100%;max-width:1080px;margin:0 auto; }

        /* ── Section reveal ── */
        .sec {
          margin-bottom:var(--external-section-gap);
          opacity:0;transform:translateY(28px);
          transition:opacity 0.7s ease,transform 0.7s ease;
        }
        .sec.sec-in { opacity:1;transform:none; }

        /* ── Section Header ── */
        .sh { text-align:center;margin-bottom:3rem; }
        .sh-tag {
          display:block;font-family:'Share Tech Mono',monospace;
          font-size:0.62rem;color:#555;letter-spacing:1.5px;margin-bottom:4px;
        }
        .sh-title {
          font-family:'Orbitron',sans-serif;
          font-size:clamp(1.4rem,3vw,2rem);font-weight:900;color:#fff;letter-spacing:4px;
          margin-bottom:0.8rem;display:inline-block;position:relative;
        }
        .sh-title::after {
          content:'';position:absolute;left:0;bottom:-4px;
          width:0;height:2px;background:linear-gradient(90deg,#ff4444,#ff6666);
          transition:width 1.2s ease;
        }
        .sec-in .sh-title::after { width:100%; }
        .sh-bar {
          height:1px;width:60px;margin:0.8rem auto 0;
          background:linear-gradient(90deg,transparent,#ff4444,transparent);
        }
        .sh-sub { font-size:0.95rem;color:#7a8a9a;max-width:540px;margin:0.8rem auto 0;line-height:1.65; }

        /* ── HERO ── */
        .hero {
          padding:6.5rem 0 4.5rem;
          text-align:center;
          opacity:0;transform:translateY(26px);
          transition:opacity 0.9s ease,transform 0.9s ease;
        }
        .hero.vis { opacity:1;transform:none; }

        .hero-sys-tag {
          display:inline-flex;align-items:center;gap:8px;
          background:rgba(255,68,68,0.07);border:1px solid rgba(255,68,68,0.2);
          border-radius:2px;padding:5px 14px;margin-bottom:1.8rem;
          font-family:'Share Tech Mono',monospace;font-size:0.62rem;color:#ff7766;letter-spacing:1.5px;
        }
        .sys-dot {
          width:7px;height:7px;border-radius:50%;background:#ff4444;
          box-shadow:0 0 8px #ff4444;animation:blink 1.6s ease-in-out infinite;
        }
        @keyframes blink{0%,100%{opacity:1;box-shadow:0 0 8px #ff4444}50%{opacity:0.3;box-shadow:0 0 3px #ff4444}}

        .hero-title {
          font-family:'Orbitron',sans-serif;
          font-size:clamp(2.8rem,7vw,5.5rem);font-weight:900;
          color:#fff;line-height:0.9;margin-bottom:1.6rem;
        }
        .hero-sub { display:block; }
        .hero-red {
          color:#ff2222;
          text-shadow:0 0 18px rgba(255,34,34,0.7),0 0 40px rgba(255,34,34,0.35);
          animation:glow-pulse 3s ease-in-out infinite;
        }
        @keyframes glow-pulse{0%,100%{text-shadow:0 0 18px rgba(255,34,34,0.7),0 0 40px rgba(255,34,34,0.35)}50%{text-shadow:0 0 28px rgba(255,34,34,0.95),0 0 60px rgba(255,34,34,0.55)}}

        .hero-divider {
          display:flex;align-items:center;gap:1rem;margin:0 auto 1.5rem;max-width:460px;
        }
        .hd-line { flex:1;height:1px;background:linear-gradient(90deg,transparent,#ff4444); }
        .hd-line-r { background:linear-gradient(90deg,#ff4444,transparent); }
        .hd-label {
          font-family:'Share Tech Mono',monospace;font-size:0.6rem;
          color:#ff6644;letter-spacing:3px;white-space:nowrap;
        }
        .hero-desc { font-size:1.1rem;color:#8a97a8;line-height:1.75;max-width:560px;margin:0 auto 1.6rem; }
        .hero-underline {
          width:120px;height:2px;
          background:rgba(255,68,68,0.2);border-radius:1px;
          overflow:hidden;position:relative;margin:0 auto;
        }
        .hu-sweep {
          position:absolute;top:0;left:-100%;width:50%;height:100%;
          background:linear-gradient(90deg,transparent,#ff4444,transparent);
          animation:sweep-line 2.5s ease-in-out infinite;
        }
        @keyframes sweep-line{0%{left:-100%}100%{left:200%}}

        /* ── Glass Card ── */
        .glass-card {
          background:rgba(8,8,14,0.84);
          border:1px solid rgba(255,68,68,0.12);border-radius:5px;
          position:relative;overflow:hidden;backdrop-filter:blur(18px);
          transition:border-color 0.3s,box-shadow 0.3s,transform 0.3s;
        }
        .glass-card:hover {
          border-color:rgba(255,68,68,0.35);
          box-shadow:0 0 28px rgba(255,68,68,0.1),inset 0 0 20px rgba(255,68,68,0.04);
          transform:translateY(-4px);
        }
        .card-glow-top {
          position:absolute;top:0;left:0;right:0;height:1px;
          background:linear-gradient(90deg,transparent,rgba(255,68,68,0.65),transparent);
          pointer-events:none;
        }
        .card-edge {
          position:absolute;bottom:0;left:0;right:0;height:1px;
          background:linear-gradient(90deg,transparent,rgba(255,68,68,0.18),transparent);
          pointer-events:none;
        }

        /* ── Info Cards ── */
        .info-grid {
          display:grid;grid-template-columns:repeat(auto-fit,minmax(280px,1fr));
          gap:1.8rem;width:100%;
        }
        .info-card {
          padding:2.5rem;text-align:center;cursor:pointer;
          animation:fadeup 0.5s ease both;
        }
        @keyframes fadeup{from{opacity:0;transform:translateY(14px)}to{opacity:1;transform:none}}
        .sec-in .info-card { animation:fadeup 0.5s ease both; }

        .info-icon-wrap {
          width:70px;height:70px;border-radius:50%;
          background:rgba(255,68,68,0.06);border:1px solid rgba(255,68,68,0.18);
          display:flex;align-items:center;justify-content:center;
          margin:0 auto 1.4rem;position:relative;
          transition:background 0.3s,box-shadow 0.3s,transform 0.3s;
        }
        .info-card:hover .info-icon-wrap {
          background:rgba(255,68,68,0.14);
          box-shadow:0 0 22px rgba(255,68,68,0.3);
          transform:scale(1.08);
        }
        .info-icon-ring {
          position:absolute;inset:-7px;border-radius:50%;
          border:1px solid rgba(255,68,68,0.2);
          animation:ring-pulse 2.8s ease-in-out infinite;pointer-events:none;
        }
        @keyframes ring-pulse{0%,100%{opacity:0.5;transform:scale(1)}50%{opacity:1;transform:scale(1.06)}}
        .info-title {
          font-family:'Orbitron',sans-serif;font-size:0.8rem;font-weight:700;
          color:#ff4444;letter-spacing:3px;margin-bottom:0.9rem;
        }
        .info-details {
          font-size:0.9rem;color:#8a97a8;line-height:1.75;white-space:pre-line;
        }

        /* ── Social Grid ── */
        .social-grid {
          display:grid;
          grid-template-columns:repeat(auto-fit,minmax(220px,1fr));
          gap:1.2rem;width:100%;
        }
        .social-card {
          position:relative;overflow:hidden;
          background:rgba(8,8,14,0.84);
          border:1px solid rgba(255,68,68,0.1);border-radius:5px;
          padding:1.5rem;text-decoration:none;
          display:flex;flex-direction:column;gap:0.5rem;
          transition:all 0.28s ease;cursor:pointer;
          animation:fadeup 0.5s ease both;
        }
        .sec-in .social-card { animation:fadeup 0.5s ease both; }
        .social-card:hover {
          border-color:rgba(255,68,68,0.4);
          transform:translateY(-4px);
          box-shadow:0 6px 24px rgba(255,68,68,0.12);
        }
        .sc-top { display:flex;align-items:center;gap:10px; }
        .sc-icon {
          display:flex;align-items:center;flex-shrink:0;
          transition:filter 0.25s,transform 0.25s;
        }
        .social-card:hover .sc-icon {
          filter:drop-shadow(0 0 6px var(--sc));
          transform:scale(1.12);
        }
        .sc-name {
          font-family:'Rajdhani',sans-serif;font-size:0.95rem;font-weight:700;
          color:#fff;letter-spacing:0.5px;text-transform:uppercase;
        }
        .sc-account {
          font-family:'Share Tech Mono',monospace;font-size:0.62rem;
          color:#7a8a9a;letter-spacing:0.5px;padding-left:2px;
          transition:color 0.25s;
        }
        .social-card:hover .sc-account { color:#ff8877; }
        .sc-glow-line {
          position:absolute;bottom:0;left:0;right:0;height:1px;
          background:linear-gradient(90deg,transparent,#ff4444,transparent);
          opacity:0;transition:opacity 0.3s;
        }
        .social-card:hover .sc-glow-line { opacity:1; }
        .sc-hover-bg {
          position:absolute;inset:0;
          background:linear-gradient(135deg,rgba(255,68,68,0.04),transparent);
          opacity:0;transition:opacity 0.3s;pointer-events:none;
        }
        .social-card:hover .sc-hover-bg { opacity:1; }

        /* ── Form ── */
        .form-card { padding:3rem;width:100%; }
        .form-card-sweep {
          position:absolute;inset:0;pointer-events:none;
          background:radial-gradient(ellipse at 20% 50%,rgba(255,34,34,0.05),transparent 65%);
          animation:form-sweep 7s ease-in-out infinite alternate;
        }
        @keyframes form-sweep{from{opacity:0.6}to{opacity:1}}
        .form { position:relative;z-index:1;display:flex;flex-direction:column;gap:1.5rem; }
        .form-row { display:grid;grid-template-columns:1fr 1fr;gap:1.5rem; }
        .form-group { display:flex;flex-direction:column;gap:6px; }
        .f-label {
          font-family:'Share Tech Mono',monospace;font-size:0.6rem;
          color:#ff6644;letter-spacing:2px;
        }
        .f-input-wrap { position:relative; }
        .f-input, .f-textarea {
          width:100%;
          background:rgba(255,255,255,0.03);
          border:1px solid rgba(255,68,68,0.18);border-radius:3px;
          padding:0.8rem 1rem;color:#e0e0e0;
          font-family:'Rajdhani',sans-serif;font-size:0.95rem;font-weight:500;
          transition:border-color 0.3s,box-shadow 0.3s,background 0.3s;
          outline:none;
        }
        .f-input::placeholder, .f-textarea::placeholder { color:#4a5568;font-size:0.9rem; }
        .f-input:focus, .f-textarea:focus {
          border-color:#ff4444;
          box-shadow:0 0 0 2px rgba(255,68,68,0.12),0 0 14px rgba(255,68,68,0.1);
          background:rgba(255,68,68,0.04);
        }
        .f-border-anim {
          position:absolute;bottom:0;left:50%;right:50%;height:1px;
          background:#ff4444;box-shadow:0 0 8px #ff4444;
          transition:left 0.35s ease,right 0.35s ease;pointer-events:none;
        }
        .f-input-wrap:focus-within .f-border-anim { left:0;right:0; }
        .f-textarea { resize:vertical;min-height:130px; }

        .submit-btn {
          position:relative;overflow:hidden;
          background:#cc1111;border:none;border-radius:3px;
          cursor:pointer;padding:0;align-self:flex-start;
          font-family:'Orbitron',sans-serif;
          box-shadow:0 0 16px rgba(255,17,17,0.3);
          animation:btn-pulse 2.5s ease-in-out infinite;
          transition:transform 0.25s,box-shadow 0.25s;
        }
        @keyframes btn-pulse{0%,100%{box-shadow:0 0 14px rgba(255,34,34,0.3)}50%{box-shadow:0 0 28px rgba(255,34,34,0.6)}}
        .submit-btn:hover { transform:translateY(-2px) scale(1.02);box-shadow:0 0 32px rgba(255,34,34,0.55); }
        .sb-shine {
          position:absolute;top:0;left:-80%;width:50%;height:100%;
          background:linear-gradient(90deg,transparent,rgba(255,255,255,0.15),transparent);
          transition:left 0.5s ease;
        }
        .submit-btn:hover .sb-shine { left:130%; }
        .sb-inner {
          position:relative;z-index:1;display:flex;align-items:center;gap:8px;
          padding:0.9rem 2.2rem;
          font-size:0.7rem;font-weight:700;color:#fff;letter-spacing:2px;
        }

        /* ── CTA ── */
        .cta-sec { }
        .cta-card { padding:3.5rem;width:100%;text-align:center; }
        .cta-sweep {
          position:absolute;inset:0;pointer-events:none;
          background:radial-gradient(ellipse at 50% 50%,rgba(255,34,34,0.07),transparent 70%);
          animation:cta-sweep 6s ease-in-out infinite alternate;
        }
        @keyframes cta-sweep{from{transform:scaleX(0.8)}to{transform:scaleX(1.1)}}
        .cta-alert {
          display:inline-flex;align-items:center;gap:8px;
          font-family:'Share Tech Mono',monospace;font-size:0.6rem;
          color:#ff6644;letter-spacing:2px;margin-bottom:1.2rem;
        }
        .ca-dot {
          width:6px;height:6px;border-radius:50%;background:#ff4444;
          box-shadow:0 0 6px #ff4444;animation:blink 1s infinite;
        }
        .cta-title {
          font-family:'Orbitron',sans-serif;
          font-size:clamp(1.4rem,3vw,2rem);font-weight:900;
          color:#fff;letter-spacing:3px;margin-bottom:1rem;
        }
        .cta-desc { font-size:1rem;color:#7a8a9a;line-height:1.7;margin-bottom:2rem;max-width:580px;margin-left:auto;margin-right:auto; }
        .cta-btns { display:flex;gap:1.2rem;justify-content:center;flex-wrap:wrap; }

        .btn-primary {
          position:relative;overflow:hidden;
          background:#dd1111;border:none;border-radius:3px;
          cursor:pointer;padding:0;
          font-family:'Orbitron',sans-serif;
          box-shadow:0 0 16px rgba(255,17,17,0.3);
          transition:transform 0.25s,box-shadow 0.25s;
        }
        .btn-primary:hover { transform:translateY(-3px) scale(1.03);box-shadow:0 0 32px rgba(255,34,34,0.55); }
        .btn-shine {
          position:absolute;top:0;left:-80%;width:50%;height:100%;
          background:linear-gradient(90deg,transparent,rgba(255,255,255,0.15),transparent);
          transition:left 0.5s ease;
        }
        .btn-primary:hover .btn-shine { left:130%; }
        .btn-inner {
          position:relative;z-index:1;display:flex;align-items:center;gap:8px;
          padding:0.9rem 2.2rem;
          font-size:0.7rem;font-weight:700;color:#fff;letter-spacing:2px;
        }
        .btn-secondary {
          background:transparent;color:#ff4444;
          border:1px solid rgba(255,68,68,0.4);border-radius:3px;
          padding:0.9rem 2.2rem;cursor:pointer;
          font-family:'Orbitron',sans-serif;font-size:0.7rem;font-weight:600;letter-spacing:2px;
          transition:all 0.25s;
        }
        .btn-secondary:hover {
          background:rgba(255,68,68,0.1);border-color:#ff4444;
          box-shadow:0 0 18px rgba(255,68,68,0.2);transform:translateY(-2px);
        }

        /* ── Snackbar ── */
        .snackbar {
          position:fixed;bottom:2rem;left:50%;transform:translateX(-50%);
          z-index:9999;animation:snack-in 0.35s ease;
        }
        @keyframes snack-in{from{opacity:0;transform:translateX(-50%) translateY(14px)}to{opacity:1;transform:translateX(-50%) translateY(0)}}
        .snackbar-inner {
          background:rgba(6,8,14,0.96);
          border:1px solid rgba(68,255,136,0.3);border-radius:4px;
          overflow:hidden;min-width:320px;max-width:480px;
          box-shadow:0 0 24px rgba(68,255,136,0.12),0 8px 32px rgba(0,0,0,0.4);
        }
        .snackbar-glow-top {
          height:1px;
          background:linear-gradient(90deg,transparent,rgba(68,255,136,0.7),transparent);
        }
        .sb-row {
          display:flex;align-items:center;gap:10px;padding:1rem 1.2rem;
        }
        .sb-check { display:flex;align-items:center;flex-shrink:0; }
        .sb-msg {
          flex:1;font-family:'Rajdhani',sans-serif;font-size:0.9rem;
          color:#e0e0e0;font-weight:500;line-height:1.4;
        }
        .sb-close {
          background:none;border:none;color:#7a8a9a;font-size:1.3rem;
          cursor:pointer;padding:0;transition:color 0.2s;flex-shrink:0;
        }
        .sb-close:hover { color:#ff6644; }
        .sb-progress { height:2px;background:rgba(68,255,136,0.1); }
        .sb-bar {
          height:100%;background:linear-gradient(90deg,#44ff88,#22cc66);
          box-shadow:0 0 6px #44ff88;transition:width 0.1s linear;
        }

        /* ── Responsive ── */
        @media(max-width:768px){
          .wrapper{padding:0 var(--external-content-x-mobile) var(--external-page-bottom-mobile);}
          .hero{padding:5rem 0 3rem;}
          .info-grid{grid-template-columns:1fr;}
          .social-grid{grid-template-columns:repeat(2,1fr);}
          .form-row{grid-template-columns:1fr;}
          .form-card{padding:2rem;}
          .cta-card{padding:2rem;}
          .cta-btns{flex-direction:column;align-items:center;}
          .btn-primary,.btn-secondary{width:100%;justify-content:center;}
          .sec{margin-bottom:var(--external-section-gap-mobile);}
        }
        @media(max-width:480px){
          .social-grid{grid-template-columns:1fr;}
          .submit-btn{width:100%;}
          .sb-inner,.btn-inner{justify-content:center;}
        }
      `}</style>
    </div>
  );
};

/* ── Form Field subcomponent ── */
const FormField = ({ label, name, type, value, onChange, placeholder }) => (
  <div className="form-group">
    <label className="f-label">{label}</label>
    <div className="f-input-wrap">
      <input type={type} name={name} value={value} onChange={onChange} className="f-input" placeholder={placeholder} />
      <div className="f-border-anim" />
    </div>
  </div>
);

export default ContactUs;